import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import {iconsSet as icons} from './assets/icons/icons.js'
import store from './store'
import axios from "axios";
import i18n from './i18n'
import "isomorphic-fetch"
import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
import VTree from 'vue-tree-halower'
import CDataTableFixed from "./views/panel/DataTableFixed/CDataTableFixed";

Vue.component('CDataTableFixed', CDataTableFixed);
export const bus = new Vue();

import CInputCurrency from "./views/panel/CInputCurrency/CInputCurrency";

Vue.component('CInputCurrency', CInputCurrency);

import CSelectDefaultValue from "./views/panel/includes/CSelectDefaultValue.vue";

Vue.component('CSelectDefaultValue', CSelectDefaultValue);

Vue.use(VTree)
//***************************************
import * as apis from './functions/public_axios'

Vue.prototype.$apis = apis;

// import VueHtmlToPaper from 'vue-html-to-paper/src/index';
import VueHtmlToPaper from './CustomElements/html_paper_print_index';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes',
    ],
    styles: [
        '/css/bootstrap.min.css',
        '/css/print.css?ver=' + process.env.VUE_APP_VERSION,

    ]
}

Vue.use(VueHtmlToPaper, options);


//***************************************
// import VuePersianDatetimePicker from 'vue-persian-datetime-picker/src/picker/VuePersianDatetimePicker';
import VuePersianDatetimePicker from "@/CustomElements/VuePersianDatetimePickerWithWeek";

Vue.component('date-picker', VuePersianDatetimePicker);

axios.interceptors.request.use((config) => {

    if (config.show_pros == null) {
        bus.$emit("show_spinner", 'true');

    }

    return config;
}, (error) => {
    // trigger 'loading=false' event here
    // console.log("axios false");
    bus.$emit("show_spinner", 'false');

    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    // trigger 'loading=false' event here
    bus.$emit("show_spinner", 'false');

    return response;
}, (error) => {
    // trigger 'loading=false' event here
    bus.$emit("show_spinner", 'false');

    return Promise.reject(error);
});

import moment from 'moment-jalaali'

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.prototype.$log = console.log.bind(console);
Vue.mixin({
        data() {
            return {
                pagination_table: true,
                filter_table: true,
            }
        },
        computed: {
            get_pagination() {
                return this.pagination_table;
            },
            get_filter_table() {
                return this.filter_table;
            },
        },
        methods: {
            focusNext(elem) {
                elem = elem.srcElement
                console.log(elem)
                const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).focus();
                if (elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).disabled == true) {
                    console.log("salam is desabled")
                }
            },
            another_focus(id) {
                setTimeout(function () {
                    document.getElementById(id).focus()
                }, 200);
            },
            get_currency(number,fixed) {
                number = number.toString().replace(/,/g, '');
if(fixed==null){
     fixed = parseInt(localStorage.getItem('currency_digits'));
}

                var final_number = parseFloat(number);
                number = final_number.toFixed(fixed);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            get_currency_no_fix(number) {
                var final_number = parseFloat(number);

                number = final_number;
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            get_currency_int(number) {
                var final_number = parseInt(number);

                number = final_number
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            get_weight(number) {
                number = Math.abs(number);

                var fixed = 0;
                var final_number = parseFloat(number);
                if (final_number % 1 != 0) {
                    number = final_number.toFixed(fixed);
                } else {
                    number = parseInt(number)
                }
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            currency_symbol() {
                if (localStorage.getItem('currency_symbol') == null || localStorage.getItem('currency_symbol') == 'null') {
                    return "";
                } else {
                    return " " + localStorage.getItem('currency_symbol') + " "
                }
            },
            currency_with_symbol(number) {
                number = number.toString().replace(/,/g, '');
                number = this.get_currency(number);
                if (i18n.locale == 'fa') {
                    return number + this.currency_symbol();
                } else {
                    return this.currency_symbol() + number
                }
            },
            currency_with_symbol_no_fix(number) {
                number = number.toString().replace(/,/g, '');
                number = this.get_currency_no_fix(number);
                if (i18n.locale == 'fa') {
                    return number + this.currency_symbol();
                } else {
                    return this.currency_symbol() + number
                }
            },
            calculate_items(list, item) {

                var total = 0;

                // try{
                list.forEach(function (val) {
                    if (val[item] != null) {
                        val[item] = val[item].toString().replace(/,/g, '');
                        total += parseFloat(val[item]);
                    }

                })
                return total;
                // }catch(e){
                //     return total;
                // }

            },
            get_date(date) {
                var date_format = localStorage.getItem('setting_date_format');
                var final_date = "";
                if (i18n.locale == "fa") {
                    date_format = date_format.replace("YYYY", 'jYYYY')
                    date_format = date_format.replace("MM", 'jMM')
                    date_format = date_format.replace("DD", 'jDD')
                    final_date = moment(date).locale('fa').format(date_format);
                } else {
                    final_date = moment(date).locale('en').format(date_format);
                }
                if (final_date == "Invalid date") {
                    final_date = date;
                }
                return final_date;

            },
            get_date_time(date) {
                var date_format = localStorage.getItem('setting_date_format');
                var final_date = "";
                if (i18n.locale == "fa") {
                    date_format = date_format.replace("YYYY", 'jYYYY')
                    date_format = date_format.replace("MM", 'jMM')
                    date_format = date_format.replace("DD", 'jDD')
                    final_date = moment(date).locale('fa').format(date_format);
                } else {
                    final_date = moment(date).locale('en').format(date_format);
                }
                if (final_date == "Invalid date") {
                    final_date = date;
                }
                return final_date + " " + moment(date).format('HH:mm');

            },
            get_time(date) {

                return moment(date).format('HH:mm');

            },
            get_fisrt_last_month(year, month) {
                var s_month = "";
                var change_format = ""
                if (this.$i18n.locale == 'fa') {
                    s_month = moment(month).locale(this.$i18n.locale).format("jMM");
                    change_format = 'jYYYY/jMM/jDD'
                } else {
                    s_month = moment(month).locale(this.$i18n.locale).format("MM");
                    change_format = 'YYYY/MM/DD'
                }
                console.log("s_month", s_month)
                // this.start_date = moment().locale(this.$i18n.locale).format('YYYY-MM-DD');
                var m = new moment;
                m.locale(this.$i18n.locale);
                m.year(year); // set jalali year
                m.month(parseInt(s_month) - 1); // month will be 4 and m.format('M')=='4' , jMonth Accepts numbers from 0 to 11.
                m.date(1); // set a date

                var start_date = m.format('YYYY/MM/DD');//1403/07/01 || 23/09/2024
                var end_date = m.format('YYYY/MM/DD')//1403/07/01

                console.log("start_date", start_date)

                if (this.$i18n.locale == 'fa') {
                    end_date = moment(end_date,change_format).locale('fa').endOf('jmonth').format('YYYY/MM/DD');
                } else {
                    end_date = moment(end_date).endOf('month').format('YYYY/MM/DD');

                }
                console.log("end_date", end_date)

                var start_date_out = moment(start_date, change_format).format('YYYY-MM-DD'); // 2013-8-25 16:40:00
                var end_date_out =  moment(end_date).format('YYYY-MM-DD'); // 2013-8-25 16:40:00
                console.log("start_date_out", start_date_out, end_date_out)
                return [start_date_out, end_date_out]
            },
            get_year(date) {
                var date_format = "YYYY";
                var final_date = "";
                if (i18n.locale == "fa") {
                    date_format = date_format.replace("YYYY", 'jYYYY')
                    final_date = moment(date).locale('fa').format(date_format);
                } else {
                    final_date = moment(date).locale('en').format(date_format);
                }
                if (final_date == "Invalid date") {
                    final_date = date;
                }
                return final_date;
            },
            get_filter(list, index, equal, ret) {
                var filter = list.filter(x => x[index] == equal)[0];
                if (filter != null) {
                    return filter[ret];
                } else {
                    return "";
                }
            },
            print_data(element) {
                var ele = element.target;
                var cond = true;
                while (cond) {
                    if (ele.parentElement.classList[0] == "card") {
                        cond = false;
                    }
                    ele = ele.parentElement;
                }
                var id = "print_" + Math.round(1000);
                ele.id = id;
                this.$htmlToPaper(id);
            },
            print_element(element, title) {
                this.$htmlToPaper(element, title);
            },
            print_with_header(id, header, footer) {
                var self = this;
                this.pagination_table = false;
                this.filter_table = false;
                setTimeout(function () {
                    self.$htmlToPaperHeader(id, header, footer);

                }, 150);
                setTimeout(function () {
                    self.pagination_table = true;
                    self.filter_table = true;
                }, 1000);
            },

            get_email_html(id, header, footer, receiver_email, title) {
                var self = this;
                this.pagination_table = false;
                this.filter_table = false;
                setTimeout(function () {
                    var html_email = self.$htmlForEmail(id, header, footer);
                    var formData = new FormData();
                    formData.append('html', html_email);
                    formData.append('fName', title);
                    axios.post('/GenaratePdf', formData, {}).then(function (response) {
                        if (response.data.isSuccess) {

                            var formData2 = new FormData();
                            formData2.append('file', axios.defaults.baseURL + '/' + response.data.data);
                            formData2.append('fName', title);
                            formData2.append('email', receiver_email);

                            fetch("https://demo.nyxbit.com/send_email.php",
                                {
                                    method: "POST",
                                    body: formData2
                                })
                                .then(function (res) {
                                    self.$root.modal_component.show_api_response_modals({
                                        data: {
                                            statusCode: 0,
                                            message: 'Email Sent'
                                        }
                                    })
                                })

                        }
                    }).catch(function (error) {
                    });

                }, 150);
                setTimeout(function () {
                    self.pagination_table = true;
                    self.filter_table = true;
                }, 1000);

            },
            print_with_header_title(id, header, footer, title) {
                var self = this;
                this.pagination_table = false;
                this.filter_table = false;

                setTimeout(function () {
                    self.$htmlToPaperHeaderTitle(id, header, footer, title);

                }, 150);
                setTimeout(function () {
                    self.pagination_table = true;
                    self.filter_table = true;
                }, 1000);

            },
            print_with_header_title_height(id, header, footer, title, height_height, footer_height) {
                var my_footer = document.getElementById(footer);
                var last_footer_display = my_footer.style.display;
                my_footer.style.display = "block";
                footer_height = my_footer.offsetHeight + 60;
                my_footer.style.display = last_footer_display;

                var my_header = document.getElementById(header);
                var last_header_display = my_header.style.display;
                my_header.style.display = "block";
                height_height = my_header.offsetHeight + 60;
                my_header.style.display = last_header_display;

                var self = this;
                this.pagination_table = false;
                this.filter_table = false;

                setTimeout(function () {
                    self.$htmlToPaperHeaderTitle_height(id, header, footer, title, height_height, footer_height);

                }, 150);
                setTimeout(function () {
                    self.pagination_table = true;
                    self.filter_table = true;
                }, 1000);

            },
            //********************************************8
            print_with_header_title_height_multiple_class(id, header, footer, title, height_height, footer_height) {
                // var my_footer = document.getElementsByClassName(footer);
                // var last_footer_display = my_footer.style.display;
                // my_footer.style.display = "block";
                footer_height = 300 + 60;
                // my_footer.style.display = last_footer_display;

                // var my_header = document.getElementsByClassName(header);
                // var last_header_display = my_header.style.display;
                // my_header.style.display = "block";
                height_height = 300 + 60;
                // my_header.style.display = last_header_display;

                var self = this;
                this.pagination_table = false;
                this.filter_table = false;

                setTimeout(function () {
                    self.$htmlToPaperHeaderTitle_height_multiple_class(id, header, footer, title, height_height, footer_height);

                }, 150);
                setTimeout(function () {
                    self.pagination_table = true;
                    self.filter_table = true;
                }, 1000);

            },
            get_logo() {
                return localStorage.getItem('app_logo');
            },
            get_bussiness_name() {
                return localStorage.getItem('businessName');
            },
            my_branch_name() {
                return localStorage.getItem('branchName');
            },
            my_branch_code() {
                return localStorage.getItem('branchCode');
            },
            get_user_name() {
                return localStorage.getItem("user_name");
            },
            get_min_doc_date() {
                return localStorage.getItem('fyear_min_date')
            },
            get_max_doc_date() {
                return localStorage.getItem('fyear_max_date')

            },
            get_today() {
                if (i18n.locale == "fa") {
                    return moment().locale('fa').format('YYYY-MM-DD');
                } else {
                    return moment().locale('en').format('YYYY-MM-DD');
                }
            },

            get_day_before_today(month) {
                if (i18n.locale == "fa") {
                    return moment().subtract(month, 'month').locale('fa').format('YYYY-MM-01');
                } else {
                    return moment().subtract(month, 'month').locale('en').format('YYYY-MM-01');
                }
            },
            get_day_before_today_in_day(day) {
                if (i18n.locale == "fa") {
                    return moment().subtract(day, 'day').locale('fa').format('YYYY-MM-DD');
                } else {
                    return moment().subtract(day, 'day').locale('en').format('YYYY-MM-DD');
                }
            },
            get_day_after_today_in_day(day) {
                if (i18n.locale == "fa") {
                    return moment().add(day, 'day').locale('fa').format('YYYY-MM-DD');
                } else {
                    return moment().add(day, 'day').locale('en').format('YYYY-MM-DD');
                }
            },
            get_access(access) {
                return JSON.parse(localStorage.getItem("config_permissions"))[access];
            },
            has_permission(access) {
                let permissions = localStorage.getItem("permissions");
                return permissions.includes(access);

            },
            isEnglish(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if (/^[A-Za-z0-9 ]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isPostCode(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                // char = char.toUpperCase();
                if (/^[A-Z0-9a-z ]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isNumber(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if (/^[0-9]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isNumber2(e, model) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if (/^[0-9]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isDecimal(e) {
                let char = String.fromCharCode(e.keyCode); // Get the character
                if (/^[0-9.]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isDecimal2(e, price) {

                let char = String.fromCharCode(e.keyCode); // Get the character
                if (char == "." && price.toString().includes('.')) {
                    e.preventDefault();
                }
                var fixed = parseInt(localStorage.getItem('currency_digits'));
                var price_array = price.toString().split(".");
                if (price_array[1] != null && fixed == price_array[1].length) {
                    e.preventDefault();
                }
                if (/^[0-9.]+$/.test(char)) return true; // Match with regex
                else e.preventDefault(); // If not match, don't add to input text
            },
            isDecimal_no_fix(e, price) {
                try {
                    let char = String.fromCharCode(e.keyCode); // Get the character
                    if (char == "." && price.toString().includes('.')) {
                        e.preventDefault();
                    }
                    var fixed = 7;
                    var price_array = price.toString().split(".");
                    if (price_array[1] != null && fixed == price_array[1].length) {
                        e.preventDefault();
                    }
                    if (/^[0-9.]+$/.test(char)) return true; // Match with regex
                    else e.preventDefault(); // If not match, don't add to input text
                } catch (e) {

                }

            },
            sort_array(fabric_array, unsorted, id_key, label_key) {
                var tmpAry = new Array();

                for (var i = 0; i < unsorted.length; i++) {
                    // tmpAry[i] = {value:unsorted[i][id_key],label:unsorted[i][label_key]}
                    tmpAry[i] = unsorted[i];
                    tmpAry[i].value = unsorted[i][id_key];
                    tmpAry[i].label = unsorted[i][label_key];

                }
                // console.log(tmpAry)
                tmpAry.sort((a, b) => a.label.localeCompare(b.label, undefined, {numeric: true, sensitivity: 'base'}));

                fabric_array.push(...tmpAry)
                return fabric_array;

            },
            is_year_closed() {
                if (localStorage.getItem("year_closed") == 1) {
                    return true
                } else {
                    return false
                }
            },
            red_negative(amount) {
                if (amount < 0) {
                    return 'text-danger'

                } else {
                    return ''
                }
            },
            is_year_opened() {
                if (localStorage.getItem("year_opened") == 1) {
                    return true
                } else {
                    return false
                }
            },
            year_opened_dialog() {
                bus.$emit('show_danger_modal', [this.$t("dialogs.error"), this.$t('year_is_opened_dialog')])
            },
            year_closed_dialog() {
                bus.$emit('show_danger_modal', [this.$t("dialogs.error"), this.$t('year_is_closed_dialog')])
            },
        }
    }
);


var self = this;
fetch('/x_config.json?ver=' + process.env.VUE_APP_VERSION).then(res => res.json()).then(config => {
    localStorage.setItem("website_address", config.website_address);
    localStorage.setItem("api_address", config.api_address);
    axios.defaults.baseURL = config.api_address;

    localStorage.setItem("app_name", config.app_name);
    localStorage.setItem("new_style", config.new_style);
    if (config.new_style == "true") {
        const darkThemeLinkEl = document.createElement('link')
        darkThemeLinkEl.setAttribute('rel', 'stylesheet')
        darkThemeLinkEl.setAttribute('href', '/css/new_style.css')
        darkThemeLinkEl.setAttribute('id', 'dark-theme-style')
        const docHead = document.querySelector('head')
        docHead.append(darkThemeLinkEl)
    }
    localStorage.setItem("currency", config.currency);
    localStorage.setItem("config_permissions", JSON.stringify(config.permissions));
    localStorage.setItem("weight", config.weight);
    console.log("set first is " + localStorage.getItem('language'))

    if (localStorage.getItem('language') == '' || localStorage.getItem('language') == null) {
        localStorage.setItem("language", config.language);
        console.log("set first to " + config.language)

        i18n.locale = config.language;
        if (config.language == "fa") {
            document.getElementById("root").dir = "rtl"
            console.log("set first to rtl")
        } else {
            document.getElementById("root").dir = "ltr"
            console.log("set first to ltr")

        }
    }
    if (config.multiple_language == false) {
        localStorage.setItem("language", config.language);
        i18n.locale = config.language;
    }

    localStorage.setItem("language_fallback", config.language_fallback);
    localStorage.setItem("multiple_language", config.multiple_language);
    localStorage.setItem("footer_text_right", config.footer_text_right);
    localStorage.setItem("footer_text_left", config.footer_text_left);
    localStorage.setItem("footer_image", config.footer_image);

    const formData = new FormData();
    formData.append("culture", i18n.locale);
    axios.defaults.withCredentials = true;
    get_symbol()
    axios.post('ChangeLanguage', formData, {}).then(function (response) {
        console.log(self.get_today());

    }).catch(function (error) {
    });


})

function create_vue() {

    new Vue({
        el: '#app',
        router,
        store,
        icons,
        template: '<App/>',
        i18n,
        components: {
            App
        }, data() {
            return {
                root_validate_errors: [],

            }
        }
    });
}

function get_symbol() {
    let url = "GetBusinessCurrency";
    const formData = new FormData();

    axios.post(url, formData, {}).then((res) => {
        if (res.data.statusCode != 0) {
        } else {

            var min_date = res.data.data.startYear.substring(0, 10) //: "2021-03-21T00:00:00",
            var max_date = res.data.data.endDate.substring(0, 10) //: "2021-03-21T00:00:00",
            localStorage.setItem("fyear_min_date", min_date)
            localStorage.setItem("fyear_max_date", max_date)
            localStorage.setItem("year_opened", res.data.data.yearOpened)
            localStorage.setItem("year_closed", res.data.data.yearClosed)
            localStorage.setItem('currency_symbol', res.data.data.symbol);
            localStorage.setItem('currency_name', res.data.data.currency);
            localStorage.setItem('currency_digits', res.data.data.currencyDigits);
            var date_format = res.data.data.dateFormat;
            if (date_format == null) {
                date_format = 'YYYY/MM/DD'
            }
            localStorage.setItem('setting_date_format', date_format);
            var display_time = "";
            var start_date = 0;
            var locale_config = {};
            if (i18n.locale == 'fa') {
                display_time = 'jYYYY/jMM/jDD';
                display_time = date_format;
                display_time = display_time.replace("YYYY", 'jYYYY')
                display_time = display_time.replace("MM", 'jMM')
                display_time = display_time.replace("DD", 'jDD')
                start_date = 6;
                locale_config = {
                    fa: {
                        dow: 6,
                        dir: 'rtl',
                        displayFormat: display_time,
                        lang: {
                            label: 'شمسی',
                            submit: 'تایید',
                            cancel: 'انصراف',
                            now: 'اکنون',
                            nextMonth: 'ماه بعد',
                            prevMonth: 'ماه قبل',
                        }
                    }

                }
            }
            if (i18n.locale == 'en') {
                display_time = 'YYYY/MM/DD'
                display_time = date_format;

                start_date = 1
                locale_config = {
                    en: {
                        dow: 2,
                        dir: 'ltr',
                        displayFormat: display_time,
                        lang: {
                            label: 'Miladi',
                            submit: 'Select',
                            cancel: 'Cancel',
                            now: 'Now',
                            nextMonth: 'Next month',
                            prevMonth: 'Previous month',
                        }
                    }

                }
            }
            Vue.use(VuePersianDatetimePicker, {
                props: {
                    // min:min_date,
                    // max:max_date,
                    format: "YYYY-MM-DD",
                    inputFormat: 'YYYY-MM-DD',
                    displayFormat: display_time,
                    editable: true,
                    locale: i18n.locale,
                    startDate: start_date,
                    color: "dimgray",
                    altFormat: 'YYYY-MM-DD HH:mm',
                    autoSubmit: true,

                }
            });

            create_vue();
            // get_years();
        }
    }).catch(function (error) {
        // self.loading = false;
        create_vue();
        // get_years();


    });
}

//config axios


